export const defaultProfileImage =
  "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png";

export const defaultProviderImage =
  "https://www.accountancyage.com/wp-content/themes/accountancy-age/img/company-placeholder.png";
